module.exports = __webpack_public_path__ + "img/video16.edd6f665.jpg";